import { requestDialog } from './requestDialog';
import type { UsageRestrictionWarningDialogRequest } from './usageRestrictionWarningDialogRequest';

export function showUsageRestrictionWarningDialog(req: UsageRestrictionWarningDialogRequest) {
  requestDialog(req, () => import('@mimir/web/pages/item/components/UsageRestrictionWarningDialog.vue'));
}
